import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=8dfe5604&scoped=true"
import script from "./UiCheckbox.vue?vue&type=script&lang=js"
export * from "./UiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=8dfe5604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfe5604",
  null
  
)

export default component.exports